// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { xScreen } from "@flip/XDL/Utilities";
import { addressBookStyles } from "@insite/content-library/Widgets/Addresses/AddressBook";
import { css } from "styled-components";

addressBookStyles.addressCard = {
    ...addressBookStyles?.addressCard,
    addressInfoDisplayGridItem: {
        ...addressBookStyles?.addressCard?.addressInfoDisplayGridItem,
        css: css`
            ${xScreen("lte", 320)} {
                max-width: 249px;
            }
        `,
    },
};
addressBookStyles.centeringWrapper = {
    css: css`
        height: 300px;
        width: 100%;
        display: flex;
        align-items: center;
        padding: 0 10px;
    `,
};
